import OrganizationLogo from '@/components/OrganizationLogo/logo';
import { PageLayoutSidebarLogoContainer } from '@/components/PageLayout';
import { UserMenu } from '@/pages/HomePage/OrganizationPage/Header/UserMenu';
import { useAuthUser } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { theme } from 'antd';

/**
 * Top banner: organization logo on the left, user menu on the right.
 *
 * Previously this banner also held a Segmented control with three
 * top-level tabs (Spaces / Insights / Connect). The tabs were dropped
 * because Insights was a placeholder without real content yet, and
 * surfacing three equal pillars was misleading users into expecting
 * full features there. Connect is reachable from the user-menu shortcut
 * (admin-only) and the routes (`/insights`, `/connect`) still exist for
 * future use, but the banner-level tab framework is removed for now.
 */
const DashboardHeader = () => {
  const { user } = useAuthUser();
  const navigate = useNavigate();
  const { token } = theme.useToken();

  const navigateHome = () => {
    navigate({ pathname: '/', search: '' });
  };
  return (
    <div
      className="bg-surface-sunken text-content-primary flex justify-between items-center border-b border-default relative z-20"
      style={{ boxShadow: token.boxShadowTertiary }}
    >
      <PageLayoutSidebarLogoContainer>
        <OrganizationLogo onClick={navigateHome} className="cursor-pointer" width={52} />
      </PageLayoutSidebarLogoContainer>

      <div className="flex items-center gap-2">{user && <UserMenu user={user} />}</div>
    </div>
  );
};

export default DashboardHeader;
